import React from 'react';

export interface GetConstantDomainsPaneProps {}

export default function GetConstantDomainsPane(props: GetConstantDomainsPaneProps): JSX.Element {
  return (
    <div>
      <h3>AA chains</h3>
      <p>Set constant domains for AA chains.</p>
    </div>
  );
}
